import React, { PropTypes } from 'react';
import './Field.less';

class Field extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      animateError: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({animateError: !nextProps.valid && nextProps.validationRun !== this.props.validationRun});
  }
}

Field.defaultProps = {
  valid: true
};

Field.propTypes = {
  validationRun: PropTypes.number,
  valid: PropTypes.bool
};

export default Field;



// WEBPACK FOOTER //
// ./src/components/common/Field/Field.js